<template>
    <v-card class="pa-4">        
        <v-overlay :value="processingRequest">
            <v-progress-circular 
                indeterminate color="primary"
                :size="70" :width="7"
            ></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="showProvideRemoveUserAccountReason" width="500px">
                <v-card class="search-modal">
                <h2>Why are you removing the web account?</h2>
                <v-form class="search-form">
                    <v-textarea
                    outlined
                    v-model="explanation"
                    ></v-textarea>
                    <v-btn
                            large
                            color="primary"
                            v-on:click="removeUserAccount"
                            :disabled="explanation?.trim().length == 0"
                        >Remove</v-btn>     
                </v-form>
                </v-card>
        </v-dialog>

        <v-dialog v-model="showCreateUserAccountDialog" width="500px">
                <v-card class="search-modal">
                <h2>New user account data</h2>                
                <v-alert v-if="!!errorMessage" type="error">
                    {{ errorMessage }}
                </v-alert>  
                <v-form class="search-form" v-model="newUserDataIsValid">
                        <v-text-field
                        v-model="newPortalUserInfo.username"
                        class="mr-1"
                        label="Username"
                        :rules="[(v) => !!v || 'Username is required']"
                        outlined
                        />
                        <v-text-field
                        v-model="newPortalUserInfo.password"
                        class="mr-1"
                        label="Password"
                        :rules="[(v) => !!v || 'Password is required']"
                        outlined
                        />
                        <v-text-field
                        v-model="newPortalUserInfo.createExplanation"
                        class="mr-1"
                        label="Explanation"
                        :rules="[(v) => !!v || 'Explanation is required']"
                        outlined
                        />
                    <v-btn
                            large
                            color="primary"
                            v-on:click="createUserAccount"
                            :disabled="newPortalUserInfo?.username?.trim().length == 0 || newPortalUserInfo?.password?.trim().length == 0 || newPortalUserInfo?.createExplanation?.trim().length == 0"
                        >Create</v-btn>     
                </v-form>
                </v-card>
        </v-dialog>
        <v-row class="mb-3" v-if="portalUserInfo.username">
            <v-col><h2>
    {{portalUserInfo.username }}
    <v-chip v-if="portalUserInfo.isAdmin"
            text-color="white"
            class="ma-1"
            color="red">Admin</v-chip>
            <v-chip v-if="!portalUserInfo.isAdmin"
            text-color="white"
            class="ma-1"
            color="green">User</v-chip>
</h2></v-col>
        </v-row>
       
        <div v-if="portalUserInfo.username" class="mt-3">
            
                <b>Last Login Date: </b>  {{ portalUserInfo.lastLoginDateStr }} <br />
                <div class="mt-3" v-if="userInfo.personId != portalUserInfo.personId">

                        <v-btn color="primary" v-if="portalUserInfo.isAdmin"
                                elevation="2" @click="changePortalUserRole"
                                small>Make User</v-btn>

                        <v-btn color="primary" v-else
                                elevation="2" @click="changePortalUserRole"
                                small>Make Admin</v-btn>

                        &nbsp;&nbsp;&nbsp;

                        <v-btn color="primary"
                                elevation="2"
                                @click="provideRemoveUserAccountReason"                                
                                small>Remove Web Access</v-btn>
                                                                                  
                </div>           
        </div>
        <div class="mt-3" v-else>
            <v-alert type="error">No Portal User information was found for this person.</v-alert>
            <v-btn color="primary"
                elevation="2"
                @click="showCreateUserAccountDialogFn"                                
                small>Create User Account</v-btn>
        </div>
    </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import peopleService from "@/services/admin/peopleService";
import { UserInfo } from "@/types/User";
import { PortalUserInfo } from '@/types/admin/User';

export default Vue.extend({
    name: "PortalUserDetails",
    props: {
        personId: { type: Number },
    },
    data: function () {
      return {
          newUserDataIsValid: false,
          portalUserInfo: {} as PortalUserInfo,
          newPortalUserInfo: {
            username: '',
            password: '',
            createExplanation: ''
          } as any,
          processingRequest: false,
          showProvideRemoveUserAccountReason: false,
          explanation: '',
          showCreateUserAccountDialog: false,
          createExplanation: '',
          errorMessage: '',
      }
    },
    created: function () {
        if (this.personId) {
        peopleService
            .getPortalUserById(this.personId)
            .then((res) => {
            this.portalUserInfo = res;
            })
            .catch(this.$handleError);
        }
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
    },
    watch: {
        personId: function (newVal: String) {
            peopleService
                .getPortalUserById(this.personId)
                .then((res) => {
                    this.portalUserInfo = res;
                })
                .catch(this.$handleError);
            },        
    },
    methods: {
        reloadUserInfo: function(personId: number) {
            peopleService
                .getPortalUserById(personId)
                .then((res) => {
                    this.$data.portalUserInfo = res;
                    this.explanation = '';
                    this.showProvideRemoveUserAccountReason = false;
                    this.newPortalUserInfo = {
                        username: '',
                        password: '',
                        createExplanation: ''
                    };
                    this.createExplanation = '';
                    this.showCreateUserAccountDialog = false;
                    this.processingRequest = false;
                    this.errorMessage = '';
                })
                .catch(this.$handleError);
        },
        changePortalUserRole: function () {
            peopleService
                .changePortalUserRole(this.personId)
                .then((res) => {
                    this.portalUserInfo = res;
                    window.location.reload();
                })
                .catch(this.$handleError);

        },   
        provideRemoveUserAccountReason: function () {
            this.$data.showProvideRemoveUserAccountReason = true;
        },     
        removeUserAccount: function () {
            this.showProvideRemoveUserAccountReason = false;
            this.processingRequest = true;
            peopleService
                .removeUserAccount(this.portalUserInfo.personId, this.portalUserInfo.username, this.explanation)
                .then((res) => {
                    this.reloadUserInfo(this.personId);
                    window.location.reload();
                })
                .catch(this.$handleError)
                .finally(() => this.processingRequest = false);
        },    
        showCreateUserAccountDialogFn: function () {
            this.$data.showCreateUserAccountDialog = true;
            this.newPortalUserInfo = {
                username: '',
                password: '',
                createExplanation: ''
            };
        },     
        createUserAccount: function () {
            this.processingRequest = true;
            peopleService
                .createUserAccount(this.personId, this.newPortalUserInfo.username, this.newPortalUserInfo.password, this.newPortalUserInfo.createExplanation)
                .then((res : any) => {                       
                    if(res.success)    {
                        this.$data.showCreateUserAccountDialog = false;   
                        this.reloadUserInfo(this.personId);
                        window.location.reload();
                    } else {
                        this.$data.showCreateUserAccountDialog = true;  
                        this.errorMessage = res.messages?.join(", ");
                    }
                })
                .catch(this.$handleError)
                .finally(() => {
                    this.processingRequest = false;                  
            });
        }
    },
})
</script>
